export const LogoMark = ({ className = "", spin = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-label="Alfa Gráfica Digital" role="img">
    <g className={spin ? "logo-spin" : ""} style={{ transformOrigin: "32px 32px" }}>
      <polygon points="32,5.5 54.95,18.75 54.95,45.25 32,58.5 9.05,45.25 9.05,18.75" fill="none" stroke="#FF5A00" strokeWidth="3" strokeLinejoin="miter" />
    </g>
    <path d="M32 15.3 46.5 23.6 32 32 17.5 23.6z" fill="#FF5A00" />
    <path d="M32 32 46.5 23.6v16.6L32 48.3z" fill="#FFA357" />
    <path d="M17.5 23.6 32 32v16.3l-14.5-8.1z" fill="currentColor" />
  </svg>
);

export const Wordmark = ({ dark = false, testId = "brand-logo", lg = false }) => (
  <div className={`flex items-center ${lg ? "gap-3" : "gap-3"}`} data-testid={testId}>
    <LogoMark className={`${lg ? "w-[87px] h-[87px]" : "w-[78px] h-[78px]"} ${dark ? "text-paper" : "text-ink"}`} spin />
    <div className={dark ? "text-paper" : ""}>
      <p className={`font-display ${lg ? "text-[31px]" : "text-[28px]"} leading-[0.95] tracking-[-0.03em]`}>Alfa</p>
      <p className={`font-display ${lg ? "text-[31px]" : "text-[28px]"} leading-[0.95] tracking-[-0.03em]`}>Gráfica</p>
      <p className={`font-display ${lg ? "text-[17px]" : "text-[15px]"} leading-none tracking-[0.02em] uppercase mt-1 ${dark ? "text-paper/70" : "text-[#6f6f6f]"}`}>Digital</p>
    </div>
  </div>
);
